import { Link } from "@tanstack/react-router";

import {
  NOVA_SUCCESS_STORY_SOURCE,
  type PublicTransformationStory,
} from "~/lib/shared/transformation-story";

export function TransformationStoryAttribution({
  story,
}: {
  story: PublicTransformationStory;
}) {
  if (story.source === NOVA_SUCCESS_STORY_SOURCE && story.profileCoach) {
    return (
      <span className="block text-xs leading-tight text-gray-500">
        Coach Intelligence Hub success story{" with "}
        <Link
          to="/$username"
          params={{ username: story.profileCoach.username }}
          className="hover:text-purple-600 hover:underline"
        >
          {story.profileCoach.coachName}
        </Link>
      </span>
    );
  }

  if (story.source !== NOVA_SUCCESS_STORY_SOURCE && story.workshopCoach) {
    return (
      <Link
        to="/$username"
        params={{ username: story.workshopCoach.username }}
        className="block text-xs leading-tight text-gray-500 hover:text-purple-600"
      >
        <span className="italic">{story.workshopCoach.sessionTitle}</span>
        {" with "}
        <span className="hover:underline">{story.workshopCoach.coachName}</span>
      </Link>
    );
  }

  return (
    <span className="text-xs text-gray-500">
      {story.source === NOVA_SUCCESS_STORY_SOURCE
        ? "Coach Intelligence Hub"
        : "Personal Development Summit"}
    </span>
  );
}
